import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import "../App.css";
import CtTxt from "../Components/CustomTool/CtTxt";
import CtBtn from "../Components/CustomTool/CtBtn";
import "./Table.css";

import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";

class SiteNameOfPriceList extends Component {
  state = {
    formData: {
      txtSiteName: "",
    },
  };

  //#region component

  componentDidMount() {
    localStorage.setItem("Heading", "Price Calculator List");
    this.props.verifyUserID(
      undefined,
      this.props.setUserPrivileges,
      this.props.modules.pricecalculation
    );
  }
  //#endregion function

  //#region handle

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };
  //#endregion handle

  render() {
    return (
      <form>
        <Grid
          container
          direction="column"
          justifyContent="center"
          marginTop={0}
          spacing={1}
        >
          <Grid item>
            <CtTxt
              id="txtSiteName"
              value={this.state.formData.txtSiteName}
              label="Site Name*"
              handleOnChange={this.handleOnChange}
              maxLength={100}
              width={230}
              onKeyDown={this.props.onKeyDown}
              defaultAction={() => {
                if (this.state.formData.txtSiteName.length > 0) {
                  this.props.RevisePriceWithSiteName(
                    this.state.formData.txtSiteName,
                    this.props.vac_inquery_no,
                    this.props.vac_revision_no,
                    this.props.dat_inquery_date,
                    this.props.Revise,
                    this.props.Copy
                  );
                } else {
                  this.props.toastErrorMsg(`Enter Site Name`, `txtSiteName`);
                }
              }}
            />
          </Grid>
          <Grid item marginTop={1}>
            <CtBtn
              label={"Revise Price Calculation"}
              firstletterBig={false}
              onClick={() => {
                if (this.state.formData.txtSiteName.length > 0) {
                  this.props.RevisePriceWithSiteName(
                    this.state.formData.txtSiteName,
                    this.props.vac_inquery_no,
                    this.props.vac_revision_no,
                    this.props.dat_inquery_date,
                    this.props.Revise,
                    this.props.Copy
                  );
                } else {
                  this.props.toastErrorMsg(`Enter Site Name`, `txtSiteName`);
                }
              }}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <SiteNameOfPriceList {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
